import { Navigate, useLocation, useParams } from "react-router";
import { ROUTES } from "../../components/shared/constant";

/**
 * The staff onboarding pages moved under HRIS (/hris…); these are the paths they left, kept for
 * bookmarks and emailed links. The route guard admits them (legacyOnboardingRouteAccess) so this
 * runs, and the destination is guarded on its own. The query string and hash are carried across,
 * `?tab=` turned into the route that replaced it.
 */
export function legacyOnboardingTarget(pathname: string, search: string): string {
  const params = new URLSearchParams(search);
  const tab = params.get("tab");
  params.delete("tab");
  const query = params.toString();
  const rest = query ? `?${query}` : "";
  const path = pathname.replace(/\/+$/, "");
  if (path === ROUTES.LEGACY_ONBOARDING_SETTINGS) return `${ROUTES.ONBOARDING_SETTINGS}${rest}`;
  const caseMatch = new RegExp(`^${ROUTES.LEGACY_ONBOARDING}/cases/([^/]+)`).exec(path);
  if (caseMatch) return `${ROUTES.ONBOARDING_CASE.replace(":id", caseMatch[1])}${rest}`;
  if (path === `${ROUTES.LEGACY_ONBOARDING}/offboarding` || tab === "offboarding") {
    return `${ROUTES.OFFBOARDING}${rest}`;
  }
  if (tab === "approvals") return `${ROUTES.ONBOARDING_APPROVALS}${rest}`;
  return `${ROUTES.ONBOARDING}${rest}`;
}

export function LegacyOnboardingRedirect() {
  const { pathname, search, hash } = useLocation();
  const { instanceid } = useParams();
  // A path-segment instance (`/onboarding/<instanceid>`) is not a page: it rides along as the new
  // route's own trailing segment, as every route declares `<base>/:instanceid?`.
  const isInstanceSegment =
    instanceid !== undefined &&
    pathname.replace(/\/+$/, "").endsWith(`/${instanceid}`) &&
    !/\/(offboarding|cases\/[^/]+)$/.test(pathname.replace(/\/+$/, ""));
  const target = legacyOnboardingTarget(
    isInstanceSegment ? ROUTES.LEGACY_ONBOARDING : pathname,
    search,
  );
  const [pathPart, queryPart = ""] = target.split("?");
  const withInstance = isInstanceSegment ? `${pathPart}/${instanceid}` : pathPart;
  return (
    <Navigate
      to={`${withInstance}${queryPart ? `?${queryPart}` : ""}${hash}`}
      replace
    />
  );
}

export default LegacyOnboardingRedirect;
